import { useState } from 'react';

import { isFuture, fromUnixTime } from 'date-fns';

import { usePermissions, useAuthContext } from '/src/hooks';
import { DashboardBanner } from '/src/components/DashboardBanner';
import { FEATURES } from '../constants';
import { AppLink } from '/src/features/_global/components/AppLink';

export function PaymentAlerts() {
  const { currentAccount, currentUser } = useAuthContext();
  const isStripeUser = Boolean(currentAccount?.useStripe);
  const permissions = usePermissions();

  const [hasDismissedAlerts, setHasDismissedAlerts] = useState(
    Boolean(window.sessionStorage.getItem('ce.dashboards.dismissedAlerts') ?? false),
  );

  const canManageSubscription = permissions.can('edit', FEATURES.BILLING).allowed;

  const expiredOn = currentUser.subscriptions.snapshots.expiredOn;
  const dontShowPaymentAlert = [181, 197].includes(currentUser.subscriptions.snapshots.paymentPlan.id); // ch18817,sc24366
  const isInExpiredGrace = isFuture(fromUnixTime(expiredOn));

  function dismissAlerts() {
    window.sessionStorage.setItem('ce.dashboards.dismissedAlerts', 'true');
    setHasDismissedAlerts(true);
  }

  if (isInExpiredGrace && !dontShowPaymentAlert && canManageSubscription) {
    if (hasDismissedAlerts) return null;

    return (
      <DashboardBanner title="There’s a payment issue!" data-testid="alert-banner" onClose={dismissAlerts}>
        Your Account will be deactivated soon due to a problem with payment.{' '}
        <AppLink
          to="/account/billing?billingModal=true"
          className="text-link !text-white !underline"
          target={isStripeUser ? '_blank' : '_self'}
          rel={isStripeUser ? 'noopener noreferrer' : undefined}
        >
          Please update your payment info
        </AppLink>
        .
      </DashboardBanner>
    );
  }

  return null;
}
